import { Outlet } from 'react-router-dom'
import { webUrl } from '@/constants/site'
import { Wordmark } from '@/components/Wordmark'

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-holly-50 to-sand-50 px-4 py-12">

      {/* Logo */}
      <a href={webUrl('/')} aria-label="OLLYlife — home" className="mb-8">
        <Wordmark className="text-3xl" />
      </a>

      {/* Card */}
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg shadow-holly-100/50 ring-1 ring-holly-100">
        <Outlet />
      </div>

      {/* Footer */}
      <p className="mt-6 text-xs text-muted-foreground">
        © {new Date().getFullYear()} OLLYlife — La piattaforma per gli operatori olistici
      </p>
    </div>
  )
}
